import { useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import FocusLock from 'react-focus-lock';
import { jsx } from 'react/jsx-runtime';
import { useIsomorphicLayoutEffect } from '../../hooks/useIsomorphicLayoutEffect.js';

const createElement = () => {
  if (document.getElementById('portal')) {
    return document.getElementById('portal');
  }
  const node = document?.createElement('div');
  node.setAttribute('id', 'portal');
  return node;
};
const Portal = props => {
  const {
    children,
    injectionContainer,
    autoFocus,
    focusLockOptions
  } = props;
  const [mounted, setMounted] = useState(false);
  const elementRef = useRef();
  const dom = autoFocus ? /*#__PURE__*/jsx(FocusLock, {
    as: "span",
    ...focusLockOptions,
    children: children
  }) : children;
  useIsomorphicLayoutEffect(() => {
    setMounted(true);
    elementRef.current = !injectionContainer ? createElement() : injectionContainer;
    if (!injectionContainer) {
      document.body.appendChild(elementRef.current);
    }
    return () => {
      if (elementRef.current && elementRef.current.id !== 'portal') {
        elementRef?.current?.parentNode?.removeChild(elementRef.current);
      }
    };
  }, [injectionContainer, elementRef]);
  if (!mounted) {
    return null;
  }
  return /*#__PURE__*/createPortal(dom, elementRef.current);
};
Portal.displayName = 'Portal';

export { Portal };
